__turbopack_context__.v({
  "footer": "UyPCha_footer",
  "heading": "UyPCha_heading",
  "productImage": "UyPCha_productImage",
  "subHeading": "UyPCha_subHeading",
  "wrapper": "UyPCha_wrapper",
});
